export const PurposeOption = {
  /**
   * Dark purpose for dark-themed elements for neutral information
   */
  Dark: "dark",

  /**
   * Gray purpose for gray-themed elements such as disabled or more neutral information
   */
  Gray: "gray",

  /**
   * Light purpose for light-themed elements such as subtle or less prominent information
   */
  Light: "light",

  /**
   * Info purpose for informational elements
   */
  Info: "info",

  /**
   * Success purpose for successful actions or confirmations
   */
  Success: "success",

  /**
   * Warning purpose for warning messages or alerts
   */
  Warning: "warning",

  /**
   * Danger purpose for error or destructive actions
   */
  Danger: "danger",

  /**
   * Theme customisation, to use the company/branded primary color
   */
  Primary: "primary",

  /**
   * Theme customisation, to use the company/branded secondary color
   */
  Secondary: "secondary",
} as const;

export const purposeOptions = Object.values(PurposeOption);

export type Purpose = (typeof PurposeOption)[keyof typeof PurposeOption];

export const CoreVariantOption = {
  /**
   * Solid variant for filled elements
   */
  Default: "default",

  /**
   * Outline variant for elements with a border and transparent background
   */
  Outline: "outline",

  /**
   * Secondary variant for elements with a lighter background
   */
  Secondary: "secondary",
} as const;

const coreVariantOptions = Object.values(CoreVariantOption);

export const ExtraVariantOption = {
  /**
   * Predefined ghost color element styles.
   */
  Ghost: "ghost",

  /**
   * Predefined soft color element styles
   */
  Soft: "soft",

  /**
   * Predefined white color element styles.
   */
  White: "white",

  /**
   * Text variant for text link-like buttons with no borders
   */
  Text: "text",
} as const;

const extraVariantOptions = Object.values(ExtraVariantOption);

export const allVariantOptions = [
  ...coreVariantOptions,
  ...extraVariantOptions,
];

export type ExtraVariant =
  (typeof ExtraVariantOption)[keyof typeof ExtraVariantOption];

export type CoreVariant =
  (typeof CoreVariantOption)[keyof typeof CoreVariantOption];

export const ShapeOption = {
  Default: "default",
  Pill: "pill",
} as const;

export const shapeOptions = Object.values(ShapeOption);

export type Shape = (typeof ShapeOption)[keyof typeof ShapeOption];

export const SizeOption = {
  Sm: "sm",
  Default: "default",
  Lg: "lg",
} as const;

export const sizeOptions = Object.values(SizeOption);

export type Size = (typeof SizeOption)[keyof typeof SizeOption];
